import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ISupportState {
  columnPreferences: IColumnPreference[];
}

export const initialState: ISupportState = {
  columnPreferences: []
};

const slice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    setSupportColumnPreferences: (state, action: PayloadAction<IColumnPreference[]>) => {
      state.columnPreferences = action.payload;
    },
    resetSupportState: () => initialState
  }
});

export const { setSupportColumnPreferences, resetSupportState } = slice.actions;
export const supportReducer = slice.reducer;

export const selectSupportColumnPreferences = (state: IAppState) =>
  state.support?.columnPreferences || [];
